<template>
  <div class="pa-1">
    <v-row no-gutters align="stretch">
      <v-col cols="12" md="12" class="pa-1">
        <v-card rounded="lg" class="flex-card" :loading="loading">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-card-text class="font-weight-medium" id="body_card">
            <h3><v-icon>mdi-clipboard-check</v-icon> ตั้งค่าระบบ</h3>
          </v-card-text>

          <v-list two-line>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="indigo"> mdi-lightbulb-on </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="pl-5">
                  <v-radio-group
                    v-model="seting_syss.seting_sys_grayscale"
                    @change="updatesetting()"
                    row
                  >
                    <template v-slot:label>
                      <div>
                        กำหนด
                        <strong> เปิด/ปิด ไว้อาลัย </strong>
                      </div>
                    </template>
                    <v-radio value="1">
                      <template v-slot:label>
                        <div>
                          <strong class="success--text">เปิด</strong>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio value="0">
                      <template v-slot:label>
                        <div>
                          <strong class="error--text">ปิด</strong>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  layout: "administrators",
  data() {
    return {
      switch1: true,
      loading: false,
      ApiKey: "HRvec2021",
      seting_syss: [],
      time_stamps: []
    };
  },

  async mounted() {
    await this.seting_sysQuery();
  },

  methods: {
    time_stamp() {
      const millis = Date.now();
      this.time_stamps = millis;
    },

    async seting_sysQuery() {
      try {
        this.loading = true;
        let result = await this.$http.post("seting_sys.php", {
          ApiKey: this.ApiKey,
          seting_sys_id: "1"
        });
        this.seting_syss = result.data;
      } finally {
        this.loading = false;
      }
    },

    async updatesetting() {
      Swal.fire({
        title: "ต้องการปรับการตั้งค่าระบบ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.seting_syss.ApiKey = this.ApiKey;
          let result = await this.$http.post(
            "seting_sys.update.php",
            this.seting_syss
          );

          if (result.data.status == true) {
            this.college_user = result.data;
            Swal.fire({
              icon: "success",
              title: "แก้ไขการตั้งค่าระบบเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    }
  },
  computed: {
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    }
  }
};
</script>
